import { IconProps } from '../iconProps';

export const ArrowLeft = ({ size = 24, fill = '' }: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill={fill}
      stroke='currentColor'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
      className='lucide lucide-arrow-left-icon lucide-arrow-left'
    >
      <path d='m12 19-7-7 7-7' />
      <path d='M19 12H5' />
    </svg>
  );
};

export const ChevronArrowLeft = ({ fill = '79716B' }: IconProps) => {
  return (
    <svg
      width='10'
      height='17'
      viewBox='0 0 10 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.95833 8.5L9.08333 14.625C9.29167 14.8333 9.39236 15.0764 9.38542 15.3542C9.37847 15.6319 9.27083 15.875 9.0625 16.0833C8.85417 16.2917 8.61111 16.3958 8.33333 16.3958C8.05556 16.3958 7.8125 16.2917 7.60417 16.0833L1.1875 9.6875C1.02083 9.52083 0.895833 9.33333 0.8125 9.125C0.729167 8.91667 0.6875 8.70833 0.6875 8.5C0.6875 8.29167 0.729167 8.08333 0.8125 7.875C0.895833 7.66667 1.02083 7.47917 1.1875 7.3125L7.60417 0.895834C7.8125 0.6875 8.05903 0.586806 8.34375 0.59375C8.62847 0.600695 8.875 0.708334 9.08333 0.916667C9.29167 1.125 9.39583 1.36806 9.39583 1.64583C9.39583 1.92361 9.29167 2.16667 9.08333 2.375L2.95833 8.5Z'
        fill={fill}
      />
    </svg>
  );
};
